"use strict";

import angular from "angular";

import template from "./input-mask-unit.component.html";

class InputMaskUnitComponent {
    constructor() {}

    $onInit() {}
}

InputMaskUnitComponent.$inject = [];

const name = "inputMaskUnitComponent";
const def = {
    bindings: {
        unit: "<",
        placeHolder: "@",
        ariaLabel: "@",
        model: "=",
        onBlur: "&",
        onChange: "&",
        inputType: "@",
        inputIconRight: "@",
        onClickIconRight: "&",
        isDisabled: "<",
        forceNegativeInput: "<"
    },
    controller: InputMaskUnitComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
